module.exports = __webpack_public_path__ + "img/IND-i-1-I.c6a4780c.png";